<template>
  <main>
    <md-card>
      <md-card-header>
        <div class="md-title">お知らせ</div>
      </md-card-header>

      <md-card-content v-if="errorMessages.length">
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <flash-message :errors="errorMessages"></flash-message>
          </div>
        </div>
      </md-card-content>
      <loading-spinner v-if="sending"></loading-spinner>
      <md-card-content v-else>
        <md-table class="custom-table" v-if="pagination.total !== null">
          <md-table-row>
            <md-table-head class="datetime-cell">お知らせ日</md-table-head>
            <md-table-head>件名</md-table-head>
            <md-table-head></md-table-head>
          </md-table-row>
          <md-table-row v-if="informationList.length === 0">
            <md-table-cell colspan="3">
              <span>{{noDataMessage}}</span>
            </md-table-cell>
          </md-table-row>
          <md-table-row v-for="information in informationList" :key="information.id">
            <md-table-cell>{{information.information_date}}</md-table-cell>
            <md-table-cell>{{information.subject}}</md-table-cell>
            <md-table-cell>
              <router-link
                :to="{name: 'BackendUserNotificationDetail', params: {id: information.information_id.toString()}}">
                <md-button class="md-raised">
                  詳細
                </md-button>
              </router-link>
            </md-table-cell>
          </md-table-row>
        </md-table>
        <pagination v-if="!sending && pagination.total"
                    :total="pagination.total"
                    :per-page="pagination.per_page"
                    :current-page="pagination.current_page"
                    @pagechanged="onPageChanged"
        />
        <md-snackbar :md-active.sync="showSnackBar"
                     :md-duration="snackbarDuration"
                     @md-closed="showSnackBar = false">
          <span>{{ successMessage }}</span>
          <md-button class="md-primary" @click="showSnackBar = false">閉じる</md-button>
        </md-snackbar>
      </md-card-content>
    </md-card>
  </main>
</template>

<script>
  import FlashMessage                                    from '../../../components/FlashMessage';
  import Pagination                                      from '../../../components/Pagination';
  import Common                                          from '../../../modules/common';
  import CommonMixin                                     from '../../../mixins/commonMixin';
  import {apiClientWithUserToken as apiClient, apiList,} from '../../../modules/apiClient';
  import LoadingSpinner                                  from '../../../components/LoadingSpinner';
  import {mapActions, mapGetters,}                       from 'vuex';

  export default {
    name      : "UserNotifications",
    mixins    : [CommonMixin],
    components: {
      LoadingSpinner,
      Pagination,
      FlashMessage,
    },
    data      : () => ({
        informationList: [],
        // Pagination
        pagination     : {
          total       : null,
          per_page    : Common.limitPageDefault,
          current_page: 1,
        },
        noDataMessage: Common.messages.notification.notFound,
      }
    ),
    mounted   : function () {
      this.applyState();
      this.getInformation();
    },
    computed  : {
      ...mapGetters('notifications', {
        formData : 'formData',
        isRefresh: 'isRefresh',
        isBack   : 'isBack',
      }),
    },
    methods   : {
      ...mapActions('notifications', [
        'saveFormData',
        'saveRefresh',
        'saveBack',
      ]),
      applyState() {
        if ((this.isRefresh || this.isBack) && this.formData !== null) {
          this.pagination.current_page = this.formData.page;
          this.pagination.per_page     = this.formData.limit;
        }
        this.saveRefresh(false);
        this.saveBack(false);
      },
      setMetaPagination(meta) {
        this.pagination.total        = meta.total;
        this.pagination.per_page     = meta.per_page;
        this.pagination.current_page = meta.current_page;
      },
      getInformation() {
        this.sending   = true;
        const formData = {
          page : this.pagination.current_page,
          limit: this.pagination.per_page,
        };
        this.saveFormData(formData);
        apiClient.get(apiList.information.information, {params: formData})
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            const result = response.data;
            this.setMetaPagination(result.meta);
            this.informationList = result.informations;
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false
          });
      },
      onPageChanged(page) {
        this.pagination.current_page = page;
        this.getInformation();
      },
    },
  }
</script>

<style lang="scss" scoped>
  .datetime-cell {
    min-width: 140px;
  }
</style>
